/**
 *
 * @param text is a string
 * @return true if first letter is a vowel
 */
export const isFirstLetterVowel = (text: string) => {
  const vowels = 'aeiouAEIOU';
  return text && vowels.includes(text[0]);
};
